const cookieMessages = [
  //'No local storage', 'You must enable local storage'
];

export function isCookieError(err) {
  if (err && err.message) {
    return cookieMessages.indexOf(err.message) >= 0;
  }
  return false;
}
